<template>
    <div>
       <CollectionBanner :collection="collection"/>
       
        
        <UiContentwrapper class="mt-8 md:mt-32">
            
            <UiFullcolumn>
            <div v-for="(products, type, index) in groupedProducts" :key="type" class="mb-16">
                
                <h2>{{ type }}</h2>
                <div class="grid place-content-center sm:grid-cols-2 md:grid-cols-3 gap-8">
                    <ProductModel
                        :model-value="product"
                        v-for="product in products"
                        :key="product.id"
                    />
                </div>
            

            </div>

            <!--UiParagraph class="max-w-xl" v-if="data?.collection.description">
                {{ data?.collection.description }}
            </UiParagraph-->
            
            
        </UiFullcolumn>  
        </UiContentwrapper>

        <ContentFeaturedPages v-if="collection.featuredPages" :page="collection"/>
    </div>
</template>

<script setup>
  
  import { useProductStore } from '@/stores/productStore';
  import { mapProductToGa4Item } from '@/utils/ga4Map';
  const route = useRoute();
  const productStore = useProductStore();    
  
  const { proxy } = useScriptGoogleTagManager({ id: 'GTM-TXPLJB8M' });
  // Använd useAsyncData för att SSR:a datat
  const { data: products } = await useAsyncData('collectionProducts', () => {
    return productStore.fetchCollectionProductsByHandle('all')
  });
  

  const collection = computed(() => {
      return productStore.getCollectionByHandle('all');
  });

  // Add SEO logic here
if (collection.value) {
  useCollectionSeo(collection.value); // Call the SEO composable with the "all" collection data
} else {
  console.warn(`Collection not found for handle: all`);
}
  

  const groupedProducts = computed(() => {
    // 1. Gruppindelning
      const groups = products.value.reduce((acc, product) => {
      // Om "wheelset" förekommer i productType => lägg i gruppen "Wheelsets"
      const groupKey = product.productType?.toLowerCase().includes('wheelset')
        ? 'Wheelsets'
        : product.productType || 'unknown';
      
    if (!acc[groupKey]) {
      acc[groupKey] = [];
    }
      // Lägg in produkten som den är, oförändrad
      acc[groupKey].push(product);
      return acc;
    }, {});

    // 2. Valfritt: Låt "Wheelsets" komma först
    //    Om du loopar över objektet direkt i template (v-for="(products, type) in groupedProducts")
    //    tas nycklarna i insättningsordning (ES2015-standard).
    //    Följande kod lyfter upp "Wheelsets" först om den finns:
    if (groups.Wheelsets) {
      const wheelsets = groups.Wheelsets;
      delete groups.Wheelsets; 
      // Bygger nytt objekt med "Wheelsets" först, sedan resten
      return { Wheelsets: wheelsets, ...groups };
    }

    return groups;
});

onMounted(async () => {

    console.log(`Pushing page_view for ${window.location.href} page to GTM dataLayer`);
    console.log('Collection title:', collection.value.title || '');
    proxy.dataLayer.push({
        event: 'page_view',
        pageType: 'PLP',
        pageUrl: window.location.href,
        pageTitle: collection.value.title || ''
    })

    // Track view_item_list for grouped products
    try {
        if (products.value && products.value.length > 0) {
            const listId = 'shop_all';
            const listName = window.location.pathname || '/shop';
            
            const items = products.value
                .map((p, i) =>
                    mapProductToGa4Item({
                        product: p,
                        index: i,
                        listId,
                        listName
                    })
                )
                .filter(Boolean);

            if (items.length > 0) {
                const currency =
                    products.value[0]?.priceRange?.minVariantPrice?.currencyCode ??
                    products.value[0]?.variants?.edges?.[0]?.node?.price?.currencyCode ??
                    'EUR';

                console.log('Pushing view_item_list to dataLayer', {
                    currency,
                    items
                });

                proxy.dataLayer.push({
                    event: 'view_item_list',
                    ecommerce: {
                        currency,
                        items
                    },
                    pageUrl: window.location.href
                });
            }
        }
    } catch (err) {
        console.warn('Error while pushing view_item_list analytics', err);
    }

});


</script>